import React from 'react';

import type {Spell} from '../../../generated/types';
import {EntitySeo} from '../../../lib/seo';
import {buildUrl} from '../../../lib/routes';
import {spellDescription, spellLevelText, spellSchoolText} from './spell-seo-text';

export const SpellSeo: React.FC<{
	spell: Spell;
	/** адрес страницы, если это не адрес самой записи: старая редакция открыта как вариант новой */
	path?: string;
}> = ({spell, path}) => (
	<EntitySeo
		entity={spell}
		section="spells"
		kind="заклинание"
		description={spellDescription(spell)}
		path={path ?? buildUrl('spell', {id: spell.id})}
		og={{kind: 'spell'}}
		keywords={[spellSchoolText(spell), spellLevelText(spell), ...(spell.classes || []).map((c) => c.title)]}
	/>
);
